import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// Components
import Footer from './components/Footer';
import NavBar from './components/Navbar';

// Pages
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import EyeCategory from './components/EyeCategory';
import NoseCategory from './components/NoseCategory';
import ProductCategories from './components/ProductCategories';
import NavBarContactUs from './components/NavBarContactUs';

function App() {
  return (
    <Router>
      <div className="App">

        {/* 🔥 GLOBAL NAVBAR */}
        <NavBar />

        <Routes>

          {/* ✅ MAIN ROUTES (SEO FRIENDLY) */}
          <Route path="/" element={<Home />} />
          <Route path="/eyes" element={<EyeCategory />} />
          <Route path="/nose" element={<NoseCategory />} />
          <Route path="/products" element={<ProductCategories />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<NavBarContactUs />} />

          {/* 🔥 REDIRECT OLD URLS (VERY IMPORTANT) */}
          <Route path="/eyecategory" element={<Navigate to="/eyes" />} />
          <Route path="/nosecategory" element={<Navigate to="/nose" />} />
          <Route path="/aboutus" element={<Navigate to="/about" />} />
          <Route path="/contactus" element={<Navigate to="/contact" />} />

          {/* 🔥 404 PAGE */}
          <Route 
            path="*" 
            element={
              <h1 style={{ textAlign: "center", marginTop: "50px" }}>
                404 - Page Not Found
              </h1>
            } 
          />

        </Routes>

        {/* 🔥 GLOBAL FOOTER */}
        <Footer />

      </div>
    </Router>
  );
}

export default App;